import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, onBeforeUnmount, onMounted, ref } from "vue";
import SeatSelection from "./SeatSelection.vue";
import PaymentFooter from "./payment/PaymentFooter.vue";
import { IDateInfo, ISeatInfo } from "@/domain/entities/book";
import { BookIntervalCode } from "@/types";
import ResizeObserver from "resize-observer-polyfill";


const __default__ = {
  name: "SeatAndPayment",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  turnId: {
    type: String,
    required: true,
  },
  getOnBusStopId: {
    type: String,
    required: true,
  },
  getOffBusStopId: {
    type: String,
    required: true,
  },
  bookingDates: {
    type: Array as PropType<IDateInfo[]>,
    required: true,
  },
  selectedDateInfo: {
    type: Object as PropType<IDateInfo>,
  },
  duplicateSeatNo: {
    type: String,
  },
  oneTimeFare: {
    type: Number,
  },
  totalAmount: {
    type: Number,
  },
  seatsSelectable: {
    type: Boolean,
    default: false,
  },
  currentBookInterval: {
    type: String as PropType<BookIntervalCode>,
  },
},
  emits: ["onClickSeat", "onChangedFooterHeight", "onFetchedSeatLayout"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const seatSelection = ref<InstanceType<typeof SeatSelection>>();
const footerWrapper = ref<HTMLElement>();

const shouldCheckSeatAvailability = computed(
  () =>
    props.currentBookInterval === BookIntervalCode.MONTH &&
    props.seatsSelectable &&
    !autoSeatAssign.value
);

const autoSeatAssign = ref(false);
const toggleAutoSeatAssgin = (enable: boolean) => {
  autoSeatAssign.value = enable;
};

/** footer 높이 동적으로 처리 */
const toggleShowSeatsLayout = () => {
  if (!props.seatsSelectable || !props.bookingDates.length) return;
  seatSelection.value?.toggleShowSeatsLayout();
};

/** 이벤트 처리 */
const emitOnClickSeat = (seatNo: string, selectedDateInfo?: IDateInfo) => {
  emit("onClickSeat", seatNo, selectedDateInfo);
};

const emitOnFetchedSeatLayout = (
  date: IDateInfo,
  seatInfos: (ISeatInfo | undefined)[][]
) => {
  emit("onFetchedSeatLayout", date, seatInfos);
};

const emitOnChangedFooterHeight = () => {
  emit("onChangedFooterHeight", footerWrapper.value?.clientHeight ?? 0);
};

let resizeObserver: ResizeObserver | null = null;
onMounted(() => {
  resizeObserver = new ResizeObserver(emitOnChangedFooterHeight);
  if (footerWrapper.value) {
    resizeObserver.observe(footerWrapper.value);
  }
});

onBeforeUnmount(() => {
  if (resizeObserver && footerWrapper.value) {
    resizeObserver.unobserve(footerWrapper.value);
    resizeObserver = null;
  }
});

const __returned__ = { props, emit, seatSelection, footerWrapper, shouldCheckSeatAvailability, autoSeatAssign, toggleAutoSeatAssgin, toggleShowSeatsLayout, emitOnClickSeat, emitOnFetchedSeatLayout, emitOnChangedFooterHeight, get resizeObserver() { return resizeObserver }, set resizeObserver(v) { resizeObserver = v }, SeatSelection, PaymentFooter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})